module.exports = __webpack_public_path__ + "static/img/rebel_pictgrid23_960x873.c8e0a9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/rebel_pictgrid23_960x873.jpg
// module id = h6pO
// module chunks = 0